import { render } from "./Report.vue?vue&type=template&id=210adb1d&scoped=true"
import script from "./Report.vue?vue&type=script&lang=js"
export * from "./Report.vue?vue&type=script&lang=js"

import "./Report.vue?vue&type=style&index=0&id=210adb1d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-210adb1d"

export default script